import { PRODUCT_NAME } from '../constants/brand';

export const RU = {
  common: {
    appName: PRODUCT_NAME,
    back: 'Назад',
    close: 'Закрыть',
    closeDocument: 'Закрыть документ',
    done: 'Готово',
    save: 'Сохранить',
    cancel: 'Отмена',
    continue: 'Продолжить',
    apply: 'Применить',
    read: 'Открыть документ',
    copy: 'Копировать',
    share: 'Поделиться',
    loading: 'Загрузка',
    sending: 'Отправка...',
    preparing: 'Подготовка...',
    requesting: 'Запрос...',
    retrying: 'Повторяем...',
    tryAgain: 'Попробовать снова',
    openTelegram: 'Открыть в Telegram',
    closeApp: 'Закрыть приложение',
    later: 'Позже',
    copied: 'Скопировано',
    valueCopied: '{{label}} скопировано',
    failedToCopy: 'Не удалось скопировать',
    contactSupport: 'Написать в поддержку',
    backToHome: 'На главную',
    linkCopied: 'Ссылка скопирована',
    stepOf: 'Шаг {{current}} из {{total}}',
    copiedLabels: {
      amount: 'Сумма',
      wallet: 'Адрес кошелька',
      cardNumber: 'Номер карты',
      expiry: 'Срок действия',
      cvv: 'CVV',
      nameOnCard: 'Имя',
      address: 'Адрес',
      postalCode: 'Почтовый индекс',
      city: 'Город',
      issuingCountry: 'Страна выпуска',
    },
    second: 'секунда',
    seconds: 'секунд',
  },

  startup: {
    loaderTitle: 'Загружаем приложение',
    telegramRequiredTitle: 'Откройте в Telegram',
    telegramRequiredText: 'Чтобы пользоваться сервисом, откройте его через Telegram Mini App.',
    referralRequiredTitle: 'Нужен реферальный код',
    referralRequiredText:
      'Сервис доступен только по реферальному коду. Получите приглашение и откройте приложение снова.',
    loginErrorTitle: 'Не удалось войти',
    loginErrorText: 'Проверьте соединение и попробуйте снова.',
    sessionExpiredTitle: 'Сессия истекла',
    sessionExpiredText:
      'Для вашей безопасности сессия завершена. Перезапустите приложение в Telegram заново, чтобы продолжить.',
    pmRequiredTitle: 'Разрешите сообщения в Telegram',
    pmDeniedTitle: 'Доступ к отправке сообщений обязателен',
    pmText:
      'Нам нужно разрешение чтобы бот мог отправлять сообщения в Telegram. Без него доступ к приложению невозможен.',
    allowMessages: 'Разрешить сообщения',
    openTelegram: 'Открыть Telegram',
  },

  navigation: {
    main: 'Основная навигация',
    home: 'Главная',
    history: 'История',
    referral: 'Пригласить',
    profile: 'Профиль',
    topUp: 'Пополнить',
  },

  onboarding: {
    heroTitleLine1: 'Платите криптой',
    heroTitleLine2: 'как обычными деньгами',
    heroSubtitle: 'Пополняйте USDT и платите везде, где принимают дебетовые карты.',
    getStarted: 'Начать',
    feesLimitsTitle: 'Комиссии и лимиты',
    topUps: 'ПОПОЛНЕНИЯ',
    card: 'КАРТА',
    usdtTopUp: 'Пополнение USDT',
    free: 'Бесплатно',
    minimumTopUp: 'Минимальное пополнение',
    virtualCardIssuance: 'Выпуск виртуальной карты',
    cardPayments: 'Платежи картой',
    noFee: 'Без комиссии',
    sharePhoneTitle: 'Поделитесь номером телефона',
    sharePhoneText:
      'Мы используем номер из вашего Telegram-аккаунта для защиты карты и восстановления доступа. Мы не передаем его третьим лицам.',
    sharePhoneAction: 'Поделиться телефоном',
    sharePhoneNumberAction: 'Поделиться номером',
    sharingPhone: 'Отправляем...',
    phoneNumberShared: 'Номер телефона получен',
    requestedSecurely: 'Безопасный запрос через Telegram',
    telegramOpenRequired: 'Откройте приложение в Telegram',
    phoneConfirmRequestFailed: 'Не удалось запросить подтверждение телефона. Попробуйте снова.',
    registrationFailed: 'Не удалось завершить регистрацию. Попробуйте снова.',
  },

  documents: {
    termsTitle: 'Согласие с условиями',
    submitTitle: 'Подтвердите ваше согласие',
    submitText: 'Ознакомьтесь и согласитесь с необходимыми документами, чтобы продолжить создание аккаунта.',
    updateTitle: 'Обновленные документы',
    updateText:
      `Ознакомьтесь и примите актуальные версии документов, чтобы продолжить пользоваться ${PRODUCT_NAME}.`,
    loadingDocuments: 'Загружаем документы',
    noDocuments: 'Документы недоступны.',
    agreeToDocument: 'Я согласен с документом {{title}}',
    submitDocuments: 'Принять условия',
    acceptUpdates: 'Принять условия',
    submitting: 'Отправляем',
    legalDocument: 'Юридический документ',
    version: 'Версия {{version}}',
    validFrom: 'Действует с {{date}}',
    contentUnavailable: 'Содержимое документа недоступно.',
    loadingDocument: 'Загружаем документ',
    submitFailed: 'Не удалось отправить документы.',
    loadDocumentsFailed: 'Не удалось загрузить документы.',
    loadDocumentFailed: 'Не удалось загрузить документ.',
  },

  pin: {
    createTitle: 'Создайте код доступа',
    createSubtitle: 'Введите 4-значный код для входа в приложение',
    confirmTitle: 'Подтвердите код',
    confirmSubtitle: 'Введите 4-значный код еще раз',
    passcodeMismatch: 'Коды не совпадают. Попробуйте еще раз.',
    setFailed: 'Не удалось установить код. Попробуйте еще раз.',
    setDoneTitle: 'Код установлен',
    setDoneText: 'Вы будете вводить этот код при каждом открытии приложения.',
    unlockTitle: 'Введите код доступа',
    unlockSubtitle: 'Введите 4-значный код, чтобы открыть приложение',
    forgotPin: 'Забыли PIN',
    forgotPinButton: 'Забыли PIN?',
    recoverAccess: 'Восстановление доступа',
    chooseCodeChannel: 'Выберите, как вы хотите получить код подтверждения.',
    codeChannelLabel: 'Канал получения кода',
    enterCode: 'Введите код',
    verificationCode: 'Код подтверждения',
    incorrectPasscode: 'Неверный код доступа. Попробуйте еще раз.',
    biometricAuthFailed: 'Биометрическая проверка не прошла.',
    biometricUnlockFailed: 'Не удалось войти по биометрии.',
    delete: 'Удалить',
    useBiometrics: 'Использовать биометрию',
    currentTitle: 'Введите текущий код',
    currentSubtitle: 'Введите текущий 4-значный код',
    newTitle: 'Создайте новый код',
    newSubtitle: 'Введите новый 4-значный код',
    confirmNewTitle: 'Подтвердите новый код',
    confirmNewSubtitle: 'Введите новый 4-значный код еще раз',
    changed: 'Код доступа изменен.',
    updateFailed: 'Не удалось изменить код. Попробуйте еще раз.',
    sendCode: 'Отправить код',
    resendCode: 'Отправить код снова',
    resendIn: 'Повторить через {{time}}',
    sendCodeIn: 'Отправить код через {{time}}',
    codeSentVia: 'Мы отправили 6-значный код через {{channel}} на {{target}}.',
    codeSent: 'Мы отправили 6-значный код на {{target}}.',
    invalidCode: 'Неверный код. Попробуйте еще раз.',
    tooManyCodeAttempts: 'Слишком много попыток. Запросите новый код, чтобы продолжить.',
    availableIn: 'Будет доступно через {{time}}',
    requestAnotherCodeIn: 'Новый код можно запросить через {{time}}.',
    noRecoveryChannel: 'Для этого аккаунта нет доступного способа восстановления.',
    codeFieldsAria: 'Поля {{label}}',
  },

  channels: {
    email: {
      label: 'Email',
      description: 'Отправить код на email',
    },
    telegram: {
      label: 'Telegram',
      description: 'Отправить код в Telegram',
    },
    sms: {
      label: 'СМС',
      description: 'Отправить код в СМС',
    },
    whatsapp: {
      label: 'WhatsApp',
      description: 'Отправить код в WhatsApp',
    },
    call: {
      label: 'Звонок',
      description: 'Получить код звонком',
    },
  },

  home: {
    welcomeBack: 'С возвращением',
    notifications: 'Уведомления',
    profile: 'Профиль',
    recentActivity: 'Последние операции',
    seeAll: 'Все',
    addNewCard: 'Выпустить новую карту',
    cardIssueInProgress: 'Завершите текущую заявку перед выпуском новой карты.',
    cardLimitReached: 'Достигнут лимит в 5 карт.',
    cards: 'Карты',
    loadingOperations: 'Загружаем операции по карте',
    noOperationsTitle: 'По этой карте пока нет операций',
    noOperationsText: 'Оплатите этой картой или пополните её — операции появятся здесь.',
  },

  card: {
    myCard: 'Моя карта',
    newCard: 'Выпуск карты',
    cardCreated: 'Карта создана',
    cardCreatedText: 'Ваша новая виртуальная карта готова к использованию.',
    appearance: 'Внешний вид',
    chooseStyle: 'Выберите стиль',
    styleAppliedText: 'Применяется к виртуальной карте.',
    edit: 'Изменить',
    renameCard: 'Переименовать карту',
    cardName: 'Название карты',
    chooseCard: 'Выберите карту',
    chooseCardForTopUp: 'Выберите карту для пополнения.',
    freezeQuestion: 'Заморозить карту?',
    freezeAction: 'Заморозить',
    freezeText:
      'Платежи по карте {{cardNumber}} будут отклоняться, пока карта заморожена. Разморозить ее можно в любой момент.',
    unfreeze: 'Разморозить',
    unfreezeCard: 'Разморозить карту',
    frozenNotice: 'Карта заморожена. Платежи и пополнения отклоняются, пока вы ее не разморозите.',
    frozen: 'Заморожена',
    holded: 'Не зачислено',
    processingFundsNotice:
      '{{amount}} обрабатывается и ожидает подтверждения в блокчейне. После подтверждения баланс обновится автоматически.',
    heldFundsNotice:
      '{{heldAmount}} пока не зачислено. Чтобы средства поступили на баланс, пополните карту минимум на {{minimumAmount}}.',
    blocked: 'Заблокирована',
    blockedTitle: 'Карта заблокирована',
    blockedNotice: 'Карта отключена. Платежи, пополнения и действия с картой недоступны.',
    activating: 'Выпускается',
    activatingTitle: 'Карта выпускается',
    activatingIssue: 'Выпускается',
    activatingNotice: 'Заявка на выпуск карты обрабатывается. Карта станет доступна автоматически.',
    issueConfirmingTitle: 'Ждем подтверждения',
    issueConfirmingText:
      'После получения всех необходимых подтверждений в сети карта будет отправлена на выпуск. Ожидайте сообщение от бота.',
    issueSubmittedTitle: 'Заявка отправлена',
    issueSubmittedText:
      'Ваша карта отправлена на выпуск. Ожидайте сообщение от бота.',
    pending: 'Выпускается',
    pendingIssue: 'Выпускается',
    pendingCard: 'Выпускается',
    completeActivation: 'Завершите активацию',
    topUpToActivate: 'Завершить активацию',
    issueTopUpRequired: 'Пополните карту на {{amount}}, чтобы отправить ее на выпуск.',
    issueCost: 'Стоимость выпуска карты',
    issueMaintenanceTitle: 'Технические работы',
    issueMaintenanceText: 'Выпуск карт временно недоступен. Пожалуйста, вернитесь позже.',
    issuePaymentReceivedTitle: 'Платеж получен',
    issuePaymentReceivedText:
      'Мы получили нужную сумму. После подтверждения сети карта будет отправлена на выпуск. Ожидайте сообщение от бота.',
    continueSetup: 'Продолжить',
    cancelRequest: 'Отменить заявку',
    cancelRequestQuestion: 'Отменить заявку на карту?',
    cancelRequestText: 'Заявка на карту будет удалена, а выпуск остановлен.',
    revealDetails: 'Показать реквизиты',
    cardDetails: 'Реквизиты карты',
    cardNumber: 'Номер карты',
    expiry: 'Срок действия',
    pin: 'PIN',
    changePin: 'Изменить PIN',
    changePinDescription: '6-значный PIN карты',
    newPinTitle: 'Создайте новый PIN карты',
    newPinSubtitle: 'Введите 6 разных цифр без последовательностей вроде 123 или 321',
    confirmPinTitle: 'Подтвердите PIN карты',
    confirmPinSubtitle: 'Введите новый 6-значный PIN карты еще раз',
    pinFormatError: 'Введите 6-значный PIN.',
    pinRepeatedDigits: 'Цифры PIN не должны повторяться.',
    pinConsecutiveDigits: 'PIN не должен содержать 3 последовательные цифры.',
    pinMismatch: 'PIN-коды не совпадают. Попробуйте еще раз.',
    pinChanged: 'PIN карты успешно изменен.',
    pinUpdateFailed: 'Не удалось изменить PIN карты. Попробуйте еще раз.',
    nameOnCard: 'Имя',
    issuingCountry: 'Страна',
    city: 'Город',
    address: 'Адрес',
    postalCode: 'Индекс',
    moreOptions: 'Дополнительные действия',
    closeDetails: 'Закрыть реквизиты',
    hidesAutomaticallyIn: 'Скроется автоматически через {{time}}',
    addToApplePay: 'Добавить в Apple Pay',
    addToGooglePay: 'Добавить в Google Pay',
    virtual: 'Виртуальная',
    virtualDescription: 'Для любых платежей',
    physical: 'Пластик',
    physicalDescription: 'Пластиковая карта',
    soon: 'Скоро',
    cardNameSection: 'НАЗВАНИЕ КАРТЫ',
    cardNamePlaceholder: 'Основная карта',
    nameOnCardSection: 'ИМЯ',
    namePlaceholder: 'IVAN PETROV',
    styleSection: 'СТИЛЬ КАРТЫ',
    typeSection: 'ТИП КАРТЫ',
    main: 'Основная',
    travel: 'Поездки',
    savings: 'Накопления',
    styles: {
      sunset: 'Закат',
      aurora: 'Сияние',
      mint: 'Мята',
      lagoon: 'Лагуна',
    },
  },

  walletGuide: {
    addAppleTitle: 'Добавить карту в Apple Pay',
    addAppleSubtitle:
      'Следуйте шагам в Wallet, затем подтвердите карту SMS-кодом, который придет в Telegram.',
    addGoogleTitle: 'Добавить карту в Google Pay',
    addGoogleSubtitle:
      'Следуйте шагам в Google Pay, затем подтвердите карту SMS-кодом, который придет в Telegram.',
    startWallet: 'Откройте в Wallet',
    startGoogle: 'Откройте в Google Pay',
    enterDetails: 'Введите данные карты',
    confirmWithCode: 'Подтвердите кодом',
    walletScreen: 'Wallet',
    googleScreen: 'Google Pay',
    cardDetailsScreen: 'Данные карты',
    paymentCardScreen: 'Платежная карта',
    verificationScreen: 'Подтверждение',
    verifyCardScreen: 'Проверка карты',
    appleStartBullets: [
      'Откройте приложение Wallet.',
      'Нажмите плюс в правом верхнем углу.',
      'Выберите дебетовую или кредитную карту.',
      'Нажмите «Продолжить».',
    ],
    appleDetailsBullets: [
      'Выберите ручной ввод данных карты.',
      `Скопируйте номер карты, срок действия и CVV из ${PRODUCT_NAME}.`,
      'Нажмите «Далее», затем введите срок действия и CVV.',
    ],
    appleCodeBullets: [
      'Выберите SMS как способ подтверждения.',
      'Код придет в Telegram.',
      'Вставьте код в Verification Code и нажмите «Далее».',
    ],
    googleStartBullets: [
      'Откройте Google Pay или Google Wallet.',
      'Нажмите Add to Wallet или кнопку добавления карты.',
      'Выберите платежную карту.',
      'Нажмите New credit or debit card.',
    ],
    googleDetailsBullets: [
      `Введите номер карты, срок действия и CVV из ${PRODUCT_NAME}.`,
      'Нажмите «Продолжить».',
      'Выберите SMS как способ подтверждения.',
    ],
    googleCodeBullets: [
      'Скопируйте код подтверждения из Telegram.',
      'Вставьте его в поле Code.',
      'Нажмите «Продолжить», чтобы завершить настройку.',
    ],
  },

  deposit: {
    topUp: 'Пополнить',
    topUpCard: 'Пополнение карты',
    topUpAddress: 'Адрес пополнения',
    noTopUpCardsTitle: 'Активной карты пока нет',
    noTopUpCardsText: 'Карта выпускается. Пополнение будет доступно после активации.',
    notIssuedTopUpText: 'Пополните карту на нужную сумму, чтобы отправить ее на выпуск.',
    currencyNetwork: 'Валюта и сеть',
    selectCurrency: 'Выберите валюту',
    selectNetwork: 'Выберите сеть',
    selectCurrencyNetwork: 'Выберите валюту и сеть',
    topUpAmount: 'Сумма пополнения',
    cardBalanceReceive: 'На баланс карты поступит',
    amount: 'Сумма',
    amountWithAsset: 'Сумма {{asset}}',
    processingFee: 'Комиссия за обработку',
    walletAddress: 'Адрес кошелька {{asset}}',
    received: 'Получено',
    transactions: 'Операции',
    noTransactionsYet: 'Новые операции появятся здесь, когда мы их обнаружим.',
    confirmationsValue: '{{current}}/{{total}} подтверждений',
    confirmed: 'Подтверждено',
    networkConfirmations: 'Подтверждения сети',
    confirming: 'Подтверждается',
    confirmingOnChain: 'Подтверждается в блокчейне',
    network: 'Сеть',
    status: 'Статус',
    topUpFailed: 'Пополнение не удалось',
    topUpFailedText: 'Средства не были зачислены на баланс.',
    topUpCompleted: 'Пополнение завершено',
    topUpReceived: 'Пополнение получено',
    addedToBalance: '{{amount}} добавлено на баланс.',
    viewOnExplorer: 'Открыть в {{explorer}}',
    viewOnBlockExplorer: 'Открыть в блокчейн-сканере',
    depositAmount: 'Сумма перевода',
    transferDetected:
      'Мы обнаружили перевод. Баланс карты обновится автоматически после подтверждения сети.',
    issueTransferDetected:
      'Мы обнаружили перевод. Выпуск карты продолжится автоматически после подтверждения сети.',
    qrLabel: 'QR-код кошелька для пополнения',
    showAddress: 'Показать адрес пополнения',
    selectFirst: 'Сначала выберите валюту и сеть.',
    minimumAmount: 'Минимальное пополнение - {{amount}} {{asset}}.',
    warning:
      'Отправляйте только выбранную валюту в указанной сети. Меньшие суммы могут быть проигнорированы.',
    doNotSendLess: 'Не отправляйте меньше минимальной суммы.',
    doNotSendLessAmount: 'Не отправляйте меньше {{amount}} {{asset}}.',
    autoCreditText: 'Мы зачислим средства на карту автоматически после обнаружения перевода.',
    autoIssueText:
      'Мы выпустим карту автоматически, когда полученная сумма достигнет минимальной суммы.',
    viaNetwork: 'Пополнение через {{network}}',
    depositAsset: 'Пополните {{asset}}',
    doneWaiting: 'Не ждать',
  },

  history: {
    title: 'История',
    searchPlaceholder: 'Поиск операций',
    exportAria: 'Экспорт истории',
    filterAria: 'Фильтры и сортировка',
    transactionTypeAria: 'Тип операции',
    clearSearchAria: 'Очистить поиск',
    emptyTitle: 'Операции не найдены',
    noOperationsTitle: 'Операций по картам пока нет',
    noOperationsText: 'Совершите оплату картой или пополните баланс, и операции появятся здесь.',
    noIncomeOperationsTitle: 'Пополнений пока нет',
    noIncomeOperationsText: 'Пополните карту или получите возврат, и входящие операции появятся здесь.',
    noExpenseOperationsTitle: 'Списаний пока нет',
    noExpenseOperationsText: 'Оплатите покупку картой, и списания появятся в этом разделе.',
    filteredEmptyTitle: 'По выбранным фильтрам ничего не найдено',
    filteredEmptyText: 'Попробуйте изменить период, карты или тип операции.',
    loading: 'Загружаем операции',
    all: 'Все',
    income: 'Пополнения',
    expense: 'Списания',
    spending: 'Траты',
    totalsAria: 'Траты и пополнения за выбранный период',
    showSpendingAria: 'Показать только траты',
    showIncomeAria: 'Показать только пополнения',
    showAllTransactionsAria: 'Вернуть все операции',
    loadingTotalsAria: 'Загружаем суммы',
    today: 'Сегодня',
    yesterday: 'Вчера',
    thisWeek: 'Эта неделя',
    thisMonth: 'Этот месяц',
    allTime: 'За все время',
    last90Days: 'Последние 90 дней',
    customRange: 'Свой период',
    allCards: 'Все карты',
    allCardsCaption: 'Операции по всем вашим картам',
    periodFilter: 'Период',
    cardsFilter: 'Карты',
    filtersAria: 'Фильтры истории',
    openPeriodFilterAria: 'Выбрать период',
    openCardsFilterAria: 'Выбрать карты',
    clearPeriodFilterAria: 'Сбросить выбранный период',
    clearCardsFilterAria: 'Сбросить выбранные карты',
    selectPeriod: 'Выбор периода',
    periodStart: 'Начало',
    periodEnd: 'Конец',
    chooseDate: 'Выберите дату',
    chooseEndDate: 'Выберите дату',
    wholeMonthAria: 'Выбрать месяц: {{month}}',
    resetPeriod: 'Сбросить период',
    selectCardsTitle: 'Какие карты показывать?',
    selectCardsSubtitle: 'Выберите одну или несколько карт для истории операций.',
    cardsCount: 'Карты {{count}}',
    showTransactions: 'Показать операции',
    unnamedCard: 'Карта',
    noCardsForFilterTitle: 'Карты пока недоступны',
    noCardsForFilterText: 'Когда появится выпущенная карта, её можно будет выбрать здесь.',
    weekdaysShort: ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'],
    completed: 'Выполнено',
    pending: 'В обработке',
    failed: 'Ошибка',
    newest: 'Сначала новые',
    oldest: 'Сначала старые',
    highestAmount: 'Крупные суммы',
    dateRange: 'ПЕРИОД',
    card: 'КАРТА',
    status: 'СТАТУС',
    sortBy: 'СОРТИРОВКА',
    filterTitle: 'Фильтр и сортировка',
    exportTitle: 'Выгрузка истории',
    exportDateRange: 'Период',
    exportCsv: 'Выгрузка CSV',
    exportPreparing: 'Подготовка...',
    exportFailed: 'Не удалось выгрузить историю.',
    exportNote:
      'Полная история операций будет выгружена в .csv-файл, который можно открыть в Excel, Sheets или отправить в чат.',
    downloadMissing: 'Ссылка на скачивание отсутствует',
    downloadStarted: 'Скачивание началось',
    downloadOpened: 'Ссылка на скачивание открыта',
    downloadFailed: 'Не удалось начать скачивание',
    downloadFile: 'Скачать файл',
    exportReady: 'Файл готов',
    exportReadyText: 'История операций выгружена.',
    transaction: 'Операция',
    transactionNotFound: 'Операция не найдена.',
    merchantNameInfo: {
      title: 'Не узнаёте название?',
      explanation: 'Название определяется автоматически и может быть неточным.',
      originalDescription: 'Исходное описание',
      unavailable: 'Недоступно для этой операции',
      compare: 'Сверьте дату и сумму с чеком.',
      unrecognized: 'Всё ещё не узнаёте платёж? Заморозьте карту и напишите в поддержку.',
    },
    tryDifferentSearch: 'Попробуйте другого продавца, дату или сумму.',
    resultsSummary: '{{count}} РЕЗ. · {{total}}',
    resetAll: 'Сбросить все',
    loadMore: 'Загрузить еще',
    txHash: 'Хеш транзакции',
    exchange: 'Обмен',
    sent: 'Отправлено',
    reference: 'Референс',
    category: 'Категория',
    date: 'Дата',
    paidAmount: 'Оплачено',
    amount: 'Сумма',
    cardLabel: 'Карта',
    shopping: 'Магазины',
    foodDrink: 'Еда и напитки',
    entertainment: 'Развлечения',
    topUp: 'Пополнение',
    topUpUsdt: 'Пополнение USDT',
    depositAccount: 'Пополнение счета',
    cardIssuancePayment: 'Оплата выпуска карты',
    cashWithdrawal: 'Выдача наличных',
    paymentCanceled: 'Платёж отменён',
    canceledStatus: 'Отменено',
    refund: 'Возврат',
    completedStatus: 'Выполнено',
    operationCategories: {
      shopping: 'Покупки',
      foodDrink: 'Еда и напитки',
      entertainment: 'Развлечения',
      topUp: 'Пополнение',
      cardIssuance: 'Выпуск карты',
      transport: 'Транспорт',
      travel: 'Путешествия',
      digitalServices: 'Цифровые сервисы',
      financial: 'Финансовые услуги',
      health: 'Здоровье',
      pets: 'Питомцы и ветеринария',
      agricultureGarden: 'Сад и сельское хозяйство',
      homeImprovement: 'Дом и ремонт',
      printing: 'Полиграфия',
      airlines: 'Авиабилеты',
      carRental: 'Аренда автомобилей',
      lodging: 'Отели и проживание',
      rail: 'Железнодорожный транспорт',
      publicTransport: 'Общественный транспорт',
      ambulance: 'Скорая помощь',
      taxi: 'Такси',
      deliveryStorage: 'Доставка и хранение',
      cruises: 'Круизы',
      marine: 'Водный транспорт',
      travelServices: 'Туры и путешествия',
      tollsParking: 'Платные дороги и парковки',
      otherTransport: 'Другой транспорт',
      telecom: 'Связь',
      internetServices: 'Интернет-сервисы',
      moneyTransfer: 'Денежные переводы',
      televisionStreaming: 'ТВ и стриминг',
      utilities: 'Коммунальные услуги',
      businessSupplies: 'Товары для бизнеса',
      officeSupplies: 'Канцтовары и офис',
      marketplaces: 'Маркетплейсы',
      generalRetail: 'Универсальные магазины',
      groceries: 'Продукты',
      vehicles: 'Автомобили и мототехника',
      autoParts: 'Автозапчасти',
      fuel: 'Топливо',
      evCharging: 'Зарядка электромобиля',
      clothing: 'Одежда и обувь',
      homeFurniture: 'Мебель и товары для дома',
      weapons: 'Оружие и боеприпасы',
      electronics: 'Электроника',
      music: 'Музыка',
      restaurants: 'Рестораны',
      bars: 'Бары и ночные клубы',
      fastFood: 'Фастфуд',
      digitalMedia: 'Цифровой контент',
      videoGames: 'Игры',
      appsSoftware: 'Приложения и ПО',
      pharmacies: 'Аптеки',
      alcohol: 'Алкоголь',
      secondHand: 'Секонд-хенд и антиквариат',
      sportsOutdoors: 'Спорт и активный отдых',
      booksStationery: 'Книги и канцтовары',
      jewelry: 'Украшения и часы',
      hobbiesToys: 'Хобби и игрушки',
      photo: 'Фотоуслуги и фототовары',
      giftsFlowers: 'Подарки и цветы',
      luggageLeather: 'Сумки и изделия из кожи',
      craftsArt: 'Творчество и искусство',
      medicalSupplies: 'Медицинские товары',
      beauty: 'Красота и спа',
      insurance: 'Страхование',
      directMarketing: 'Прямые продажи',
      adult: 'Контент 18+',
      subscriptions: 'Подписки',
      religious: 'Религиозные организации и товары',
      tobacco: 'Табачные изделия',
      specialtyRetail: 'Специализированные магазины',
      cashWithdrawal: 'Снятие наличных',
      financialServices: 'Финансовые услуги',
      realEstate: 'Недвижимость',
      laundryCleaning: 'Стирка и уборка',
      personalServices: 'Персональные услуги',
      funeral: 'Ритуальные услуги',
      dating: 'Знакомства',
      counseling: 'Консультации',
      businessServices: 'Бизнес-услуги',
      itServices: 'IT-услуги',
      autoService: 'Автосервис',
      repairs: 'Ремонт',
      gambling: 'Азартные игры',
      cinema: 'Кино и видео',
      liveEntertainment: 'Мероприятия и развлечения',
      recreation: 'Спорт и досуг',
      attractions: 'Парки и достопримечательности',
      healthcare: 'Врачи и клиники',
      dental: 'Стоматология',
      vision: 'Оптика и зрение',
      hospitalsCare: 'Больницы и уход',
      medicalLabs: 'Медицинские лаборатории',
      legal: 'Юридические услуги',
      education: 'Образование',
      childcare: 'Уход за детьми',
      charity: 'Благотворительность',
      associations: 'Общественные организации',
      political: 'Политические организации',
      architectureEngineering: 'Архитектура и инженерия',
      accounting: 'Бухгалтерия и налоги',
      government: 'Государственные платежи',
      taxes: 'Налоги',
      postal: 'Почта',
      emergency: 'Экстренные службы',
      intraCompany: 'Внутрикорпоративные платежи',
      general: 'Другое',
    },
  },

  notifications: {
    title: 'Уведомления',
    markAllRead: 'Прочитать все',
    loadMore: 'Загрузить еще',
    loading: 'Загружаем уведомления',
    loadingMore: 'Загружаем уведомления',
    emptyTitle: 'Нет уведомлений',
    emptyText: 'У вас нет непрочитанных уведомлений.',
    loadFailed: 'Не удалось загрузить уведомления.',
    loadMoreFailed: 'Не удалось загрузить больше уведомлений.',
    markReadFailed: 'Не удалось отметить уведомления прочитанными.',
    today: 'СЕГОДНЯ',
    earlier: 'РАНЕЕ',
    now: 'сейчас',
    yesterday: 'Вчера',
    locationLabel: 'Местоположение',
    ipAddressLabel: 'IP-адрес',
    deviceLabel: 'Устройство',
    fallbackTitle: 'Уведомление',
    fallbackDescription: 'Откройте уведомление, чтобы посмотреть детали.',
    passwordChangedTitle: 'Пароль изменен',
    passwordChangedText: 'Пароль аккаунта успешно обновлен.',
    emailChangedTitle: 'Email изменен',
    emailChangedText: 'Email аккаунта успешно обновлен.',
    phoneChangedTitle: 'Телефон изменен',
    phoneChangedText: 'Телефон аккаунта успешно обновлен.',
    newLoginTitle: 'Новый вход в аккаунт',
    newLoginText: 'В ваш аккаунт выполнен новый вход.',
    orderStatusTitle: 'Статус заявки обновлен',
    orderStatusText: 'Проверьте детали заявки.',
    exchangeStatusTitle: 'Статус обмена изменен',
    exchangeStatusText: 'Проверьте детали обмена.',
    offlineCheckFailedTitle: 'Офлайн-проверка не прошла',
    offlineCheckFailedText: 'Проверьте данные и следующий шаг проверки.',
    accountApprovedTitle: 'Аккаунт одобрен',
    accountApprovedText: 'Статус аккаунта изменен на «Одобрен».',
    accountRejectedTitle: 'Аккаунт отклонен',
    accountRejectedText: 'Статус аккаунта изменен на «Отклонен».',
    kycRequestedTitle: 'Запрошена KYC-анкета',
    kycRequestedText: 'Для вашего аккаунта запрошена KYC-анкета.',
    otpActivatedTitle: '2FA включена',
    otpActivatedText: 'Двухфакторная аутентификация включена для вашего аккаунта.',
    otpDisabledTitle: '2FA выключена',
    otpDisabledText: 'Двухфакторная аутентификация выключена для вашего аккаунта.',
    recoveryKeyUpdatedTitle: 'Ключ восстановления обновлен',
    recoveryKeyUpdatedText: 'Ключ восстановления 2FA обновлен.',
  },

  referral: {
    eyebrow: 'Пригласить',
    title: 'Пригласить друзей',
    heroTitle: 'Приглашайте своих друзей',
    heroText: 'Поделитесь вашей ссылкой с теми, кому доверяете.',
    heroNote: 'Скоро вы сможете зарабатывать на тратах ваших друзей.',
    friendsJoined: 'Приглашенных друзей',
    copyLink: 'Скопировать',
    copying: 'Копируем...',
    sharePreparing: 'Подготовка...',
    inviteShared: 'Приглашение отправлено',
    shareFailed: 'Не удалось поделиться в Telegram',
    missingMessageId: 'Не найден id сообщения для приглашения',
    nativeShareUnavailable: 'Отправка в Telegram недоступена',
  },

  profile: {
    title: 'Профиль',
    userFallback: 'Пользователь',
    personalInformation: 'Личная информация',
    security: 'Безопасность',
    notifications: 'Уведомления',
    language: 'Язык',
    helpSupport: 'Помощь и поддержка',
    accountSection: 'Аккаунт',
    preferencesSection: 'Настройки приложения',
    currentLanguage: 'Текущий язык',
    languageUpdateFailed: 'Не удалось изменить язык.',
    personal: {
      fullName: 'Полное имя',
      email: 'Email',
      phone: 'Телефон',
      dateOfBirth: 'Дата рождения',
      notAdded: 'Не добавлено',
      notAvailable: 'Недоступно',
      telegram: 'Telegram',
      telegramId: 'Telegram ID',
      personalDetails: 'Личные данные',
      connectedAccount: 'Связанный аккаунт',
      editFullName: 'Изменить имя',
      editEmail: 'Изменить email',
      editPhone: 'Изменить телефон',
      editDob: 'Изменить дату рождения',
      updated: 'Профиль обновлен',
      updateFailed: 'Не удалось обновить личную информацию.',
      emailUpdated: 'Email обновлен',
      phoneUpdated: 'Телефон обновлен',
      changeMethod: 'Сменить способ',
      sendCode: 'Отправить код',
      codeSent: 'Код отправлен',
      invalidEmail: 'Введите корректный email',
      invalidPhone: 'Введите корректный номер телефона',
    },
    securityPage: {
      accessSection: 'Доступ к приложению',
      appPasscode: 'Код доступа',
      enabled: 'Включено',
      notSet: 'Не задан',
      changePasscode: 'Изменить код',
      setPasscode: 'Задать код',
      biometric: 'Вход по биометрии',
      finishSetup: 'Завершить настройку',
      openTelegramSettings: 'Открыть настройки Telegram',
    },
    biometric: {
      labels: {
        face: 'Face ID',
        finger: 'Touch ID',
        unknown: 'биометрию',
      },
      enabledTitle: 'Вход по биометрии включен',
      enabledText: 'В {{productName}} теперь можно входить через {{label}} на этом устройстве.',
      enabledSuccessText: 'Теперь вы можете входить в {{productName}} через {{label}}.',
      disabledTitle: 'Вход по биометрии выключен',
      disabledText: 'Вход по биометрии выключен на этом устройстве.',
      notEnabledTitle: 'Биометрия не включена',
      notEnabledText: 'Вы сможете включить Face ID или Touch ID позже на этом экране безопасности.',
      finishTitle: 'Завершите настройку биометрии',
      finishIntroText: 'Завершите настройку, чтобы быстрее открывать приложение на этом устройстве.',
      checkPermissionTitle: 'Проверить разрешение',
      checkPermissionText: 'Вернитесь из настроек Telegram и проверьте, включен ли доступ.',
      couldNotEnableTitle: 'Не удалось включить биометрию',
      couldNotEnableText: 'Попробуйте снова или настройте позже на этом экране безопасности.',
      enableTitle: 'Включить {{label}}',
      enableText: 'Используйте {{label}}, чтобы входить в {{productName}} без ввода кода.',
      accessReason: 'Для быстрого и безопасного входа в ваш аккаунт. Биометрические данные остаются на этом устройстве.',
      enableGeneric: 'Включить биометрию',
      enableSpecific: 'Включить {{label}}',
      finishText: 'Разрешение {{label}} уже включено. Завершите настройку, чтобы использовать вход по биометрии на этом устройстве.',
      disabledAgainText: 'Вы сможете снова включить {{label}} на этом экране безопасности.',
      checkPermissionBusyText:
        'После разрешения {{label}} в настройках Telegram проверьте доступ здесь, чтобы завершить настройку.',
      permissionNeededTitle: 'Нужно разрешение {{label}}',
      permissionNeededText:
        'Разрешение {{label}} выключено в настройках Telegram. Разрешите его снова и вернитесь сюда, чтобы завершить настройку.',
      openSettingsText:
        'Откройте настройки биометрии Telegram, разрешите {{productName}} использовать {{label}} и вернитесь сюда для завершения.',
      openSettingsAction: 'Открыть настройки {{label}}',
      turnOff: 'Выключить',
      turningOff: 'Выключаем...',
      setup: 'Настроить',
      settingUp: 'Настраиваем...',
      finishSetup: 'Завершить настройку',
      checkPermission: 'Проверить разрешение',
    },
    help: {
      intro:
        `Ответы на частые вопросы о картах ${PRODUCT_NAME}, пополнениях, безопасности и восстановлении доступа.`,
      faq: 'Вопросы и ответы',
      searchPlaceholder: 'Найти ответ',
      showAll: 'Показать все вопросы',
      noResults: 'По вашему запросу ничего не найдено.',
      supportTitle: 'Нужна помощь?',
      supportText: 'Напишите нам — поможем разобраться.',
      contact: 'Написать в поддержку в Telegram',
      contactOpening: 'Открываем чат поддержки...',
      contactFailed: 'Не удалось открыть чат поддержки. Попробуйте ещё раз.',
      faqs: [
        {
          id: 'telegram-mini-app',
          question: `Почему нужно открывать ${PRODUCT_NAME} в Telegram?`,
          answer:
            `${PRODUCT_NAME} использует возможности Telegram Mini App для безопасного входа, уведомлений, передачи контакта и системных сценариев устройства. Запуск вне Telegram не поддерживается.`,
        },
        {
          id: 'pm-access',
          question: `Почему ${PRODUCT_NAME} просит разрешить отправку сообщений в Telegram?`,
          answer:
            'Мы используем личные сообщения Telegram для важных сервисных уведомлений, одноразовых кодов, подтверждений пополнений и предупреждений по карте. Без этого разрешения доступ невозможен.',
        },
        {
          id: 'referral-only',
          question: 'Зачем нужна пригласительная ссылка?',
          answer:
            `${PRODUCT_NAME} пока доступен только по приглашениям. Для создания аккаунта нужна личная ссылка от существующего пользователя.`,
        },
        {
          id: 'create-account',
          question: 'Как создать аккаунт?',
          answer:
            `Откройте ${PRODUCT_NAME} по приглашению, разрешите отправку сообщений в Telegram, поделитесь телефоном, примите документы и создайте код доступа.`,
        },
        {
          id: 'phone-verification',
          question: 'Зачем подтверждать телефон?',
          answer:
            'Подтверждение телефона защищает аккаунт и используется для восстановления, проверок безопасности карты и некоторых подтверждений платежей.',
        },
        {
          id: 'passcode',
          question: 'Для чего нужен код доступа?',
          answer:
            `Код доступа защищает вход в ${PRODUCT_NAME} внутри Telegram. Он понадобится для открытия приложения после регистрации.`,
        },
        {
          id: 'forgot-pin',
          question: 'Что делать, если я забыл PIN?',
          answer:
            'Нажмите «Забыли PIN?» на экране входа. Код можно получить в Telegram или на email, если он добавлен.',
        },
        {
          id: 'biometric',
          question: 'Можно использовать Face ID или Touch ID?',
          answer:
            'Да, если Telegram сообщает, что биометрия доступна на устройстве. Включить или выключить ее можно в настройках безопасности.',
        },
        {
          id: 'new-card',
          question: 'Когда я получу карту?',
          answer:
            `После подтверждения телефона, принятия документов и настройки кода ${PRODUCT_NAME} откроет выпуск новой карты.`,
        },
        {
          id: 'card-details',
          question: 'Где посмотреть реквизиты карты?',
          answer:
            'Откройте «Моя карта» и покажите реквизиты. Номер, срок, CVV и имя на карте можно скопировать из блока деталей.',
        },
        {
          id: 'freeze-card',
          question: 'Что происходит при заморозке карты?',
          answer:
            'Замороженную карту нельзя использовать для платежей и пополнений. Разморозить ее можно на странице карты.',
        },
        {
          id: 'top-up',
          question: 'Как работают пополнения USDT TRC-20?',
          answer:
            'Нажмите «Пополнить», выберите активную карту и отправьте USDT в сети TRC-20 на указанный адрес. Замороженные карты недоступны для пополнения.',
        },
        {
          id: 'top-up-pending',
          question: 'Почему пополнение еще в обработке?',
          answer:
            `Пополнению нужны подтверждения блокчейна и внутренняя обработка. Убедитесь, что перевод отправлен в TRC-20 и на точный адрес из ${PRODUCT_NAME}.`,
        },
        {
          id: 'wrong-network',
          question: 'Что делать, если отправил средства не в той сети?',
          answer:
            'Не отправляйте еще одну транзакцию для исправления. Напишите в поддержку и приложите хэш, чтобы команда проверила возможность восстановления.',
        },
        {
          id: 'tx-hash',
          question: 'Где проверить транзакцию пополнения?',
          answer:
            'Откройте детали операции. Для пополнений хэш ведет во внешний блок-эксплорер, если backend передал ссылку.',
        },
        {
          id: 'declined-payment',
          question: 'Почему платеж картой отклонен?',
          answer:
            'Платеж может быть отклонен, если карта заморожена, недостаточно средств, продавец ограничен или провайдер отклонил операцию.',
        },
        {
          id: 'apple-google-pay',
          question: 'Можно добавить карту в Apple Pay или Google Pay?',
          answer:
            'Да. Откройте «Моя карта», покажите реквизиты и следуйте инструкции Add to Apple Pay или Google Pay.',
        },
        {
          id: 'notifications',
          question: 'Какие уведомления я буду получать?',
          answer:
            `${PRODUCT_NAME} отправляет уведомления о безопасности, входах, карте и операциях. Счетчик виден на главной и в профиле.`,
        },
        {
          id: 'profile-data',
          question: 'Как изменить email, телефон или личные данные?',
          answer:
            'Откройте «Профиль», затем «Личная информация». Для смены email и телефона нужно подтвердить код.',
        },
        {
          id: 'referrals',
          question: 'Как приглашать друзей?',
          answer:
            'Откройте «Пригласить», чтобы поделиться личной ссылкой. Друзья, которые войдут по ней, будут привязаны к вашему приглашению.',
        },
        {
          id: 'history-export',
          question: 'Можно экспортировать историю операций?',
          answer:
            `Да. Используйте экспорт в «Истории». Когда файл готов, ${PRODUCT_NAME} попросит Telegram скачать его по ссылке backend.`,
        },
        {
          id: 'session-expired',
          question: 'Что делать, если сессия истекла?',
          answer:
            'Закройте и снова откройте Telegram Mini App. Это обновит init data Telegram и начнет новую защищенную сессию.',
        },
        {
          id: 'support',
          question: 'Как связаться с поддержкой?',
          answer:
            'Нажмите «Написать в поддержку в Telegram» и приложите карту, операцию, хэш пополнения или скриншот, чтобы команда быстрее разобралась.',
        },
      ],
    },
  },

  errors: {
    generic: 'Что-то пошло не так. Попробуйте еще раз.',
    failedSendCode: 'Не удалось отправить код. Попробуйте еще раз.',
    failedLoadNotifications: 'Не удалось загрузить уведомления.',
  },
};
